<p-avatar shape="circle" size="large">{{LabelAvatar}}</p-avatar>